import React from "react";

interface TrailIconProps {
  fill?: string;
  className?: string;
  width?: string | number;
  height?: string | number;
}

const CanicrossIcon: React.FC<TrailIconProps> = ({
  fill = "currentColor",
  className,
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 139.000000 139.000000"
      preserveAspectRatio="xMidYMid meet"
      className={className}
    >
      <g
        transform="translate(0.000000,139.000000) scale(0.100000,-0.100000)"
        fill={fill}
        stroke="none"
      >
        <path
          d="M3965 8626 c-563 -51 -1027 -177 -1512 -411 -770 -372 -1404 -952
-1853 -1695 -213 -353 -401 -824 -494 -1240 -74 -334 -100 -588 -100 -965 0
-692 138 -1294 438 -1901 203 -413 458 -771 791 -1113 334 -342 702 -611 1150
-841 347 -177 731 -310 1100 -379 348 -66 594 -86 948 -78 644 14 1196 145
1772 421 696 334 1314 872 1743 1517 289 436 516 978 621 1482 140 670 118
1388 -59 2032 -241 874 -741 1639 -1446 2216 -643 526 -1418 852 -2250 945
-191 21 -657 27 -849 10z m823 -420 c758 -101 1422 -383 2012 -855 116 -93
395 -364 500 -486 442 -513 739 -1123 869 -1780 55 -276 66 -406 66 -770 0
-288 -3 -351 -23 -494 -54 -388 -115 -629 -239 -936 -434 -1075 -1320 -1911
-2413 -2276 -372 -124 -718 -184 -1130 -196 -782 -22 -1535 189 -2208 618
-566 361 -1054 895 -1371 1499 -227 434 -362 895 -416 1425 -18 175 -21 546
-5 722 69 765 354 1465 848 2085 116 146 408 445 542 554 604 496 1279 790
2025 884 230 28 223 28 535 25 192 -2 325 -8 408 -19z"
        />
        <path
          d="M5458 6706 c-167 -45 -248 -219 -183 -392 33 -88 32 -115 -6 -159
-36 -40 -61 -44 -149 -20 -65 18 -153 20 -229 5 -29 -5 -110 -10 -180 -10
-159 0 -454 -41 -491 -68 -43 -32 -120 -208 -223 -507 -36 -106 -90 -237 -121
-297 -71 -136 -72 -162 -14 -212 52 -44 133 -86 168 -86 31 0 60 28 60 58 0
13 12 28 30 39 43 25 45 48 16 133 -14 40 -26 88 -26 105 0 37 41 103 152 247
41 53 90 126 109 163 32 63 35 66 64 61 43 -8 216 -54 221 -59 2 -2 -9 -37
-26 -78 -16 -41 -48 -132 -70 -204 -74 -234 -111 -288 -339 -499 -182 -168
-211 -210 -211 -305 -1 -86 -17 -138 -72 -235 -56 -97 -55 -99 16 -110 22 -4
193 -45 379 -91 186 -47 418 -103 515 -126 97 -22 249 -58 337 -79 472 -115
478 -116 483 -62 5 52 -16 133 -46 176 -48 69 -262 256 -387 339 -66 43 -171
104 -233 135 -128 63 -145 83 -118 139 8 17 84 107 168 198 84 92 174 192 200
223 25 32 52 57 58 57 7 0 44 -52 82 -115 120 -200 147 -223 245 -202 60 12
129 56 323 203 239 180 310 223 413 244 43 9 77 48 77 89 0 37 -41 161 -59
179 -6 6 -52 12 -101 13 -107 3 -120 -5 -139 -89 -6 -29 -20 -66 -30 -83 -24
-39 -140 -100 -281 -148 -57 -19 -116 -44 -130 -54 -14 -10 -30 -21 -36 -25
-7 -4 -32 41 -67 121 l-56 127 -4 130 c-4 92 -12 151 -27 203 -25 86 -18 125
33 168 25 21 37 25 66 20 147 -27 171 -20 171 49 0 27 6 47 16 56 10 8 14 23
12 41 -4 26 -2 28 27 28 58 0 62 24 17 120 -20 42 -21 53 -12 150 5 58 12 122
16 143 8 48 -11 71 -86 104 -57 26 -207 63 -250 62 -14 0 -46 -6 -72 -13z"
        />
        <path
          d="M2833 5863 c-18 -7 -16 -50 3 -57 9 -3 37 -6 64 -6 63 0 80 7 80 35
0 15 -8 25 -22 29 -27 7 -108 7 -125 -1z"
        />
        <path
          d="M3164 5855 c-4 -8 -4 -22 0 -30 5 -13 51 -15 358 -13 336 3 353 4
356 22 2 10 -2 22 -10 27 -7 5 -167 9 -356 9 -295 0 -343 -2 -348 -15z"
        />
        <path
          d="M2990 5593 c-62 -5 -80 -16 -80 -49 0 -50 52 -54 532 -40 305 9 327
12 312 49 -3 8 -15 18 -27 20 -40 10 -652 26 -737 20z"
        />
        <path
          d="M2068 5439 c-249 -36 -431 -200 -446 -400 -6 -89 23 -187 78 -260
134 -178 317 -237 1315 -420 152 -27 572 -118 995 -214 63 -14 219 -52 345
-85 127 -32 361 -90 520 -129 300 -73 573 -145 582 -154 15 -15 -298 0 -389
19 -28 5 -28 5 -28 -43 0 -61 35 -137 86 -184 84 -78 179 -149 200 -149 11 0
53 13 91 29 39 16 112 41 164 56 94 28 331 111 402 142 23 10 37 23 37 34 0
29 -47 151 -62 160 -24 16 -92 9 -171 -16 -43 -14 -94 -25 -113 -25 -20 0
-182 36 -362 81 -180 44 -446 109 -592 145 -297 72 -724 183 -1025 268 -110
30 -330 87 -490 125 -159 38 -344 83 -410 100 -66 16 -190 44 -275 61 -433 87
-606 151 -698 255 -70 80 -91 188 -53 272 77 169 383 264 560 173 120 -61 119
-179 -2 -235 -90 -43 -163 -27 -211 46 -29 43 -54 49 -79 21 -34 -38 -14 -98
53 -155 98 -83 254 -73 364 25 64 56 89 108 89 183 0 139 -125 253 -301 276
-78 10 -97 10 -174 -2z"
        />
        <path
          d="M3090 5280 c-24 -24 -14 -54 21 -65 28 -9 492 5 509 15 6 4 10 18 8
31 -3 22 -9 25 -68 30 -36 4 -152 7 -257 8 -181 1 -194 0 -213 -19z"
        />
        <path
          d="M3241 4992 c-38 -12 -49 -37 -27 -61 18 -20 30 -21 192 -21 144 0
175 3 188 16 21 20 20 27 -3 48 -15 14 -46 18 -172 21 -85 3 -165 1 -178 -3z"
        />
        <path
          d="M1219 4834 c-31 -15 -69 -70 -103 -144 -69 -151 -73 -282 -12 -405
99 -200 318 -286 821 -324 381 -29 1051 -52 1109 -37 35 9 56 33 56 66 0 49
-37 60 -192 60 -203 0 -924 38 -1155 61 -203 20 -402 85 -476 157 -67 64 -82
103 -82 212 0 102 14 141 86 247 16 23 29 53 29 66 0 41 -42 62 -81 41z"
        />
        <path
          d="M1440 4685 c-18 -22 -8 -99 21 -160 30 -64 130 -164 194 -194 177
-84 542 -129 1061 -134 249 -2 264 1 264 58 0 61 -8 62 -370 75 -408 14 -543
24 -700 56 -208 41 -304 100 -354 216 -15 35 -31 70 -35 78 -11 21 -65 25 -81
5z"
        />
        <path
          d="M6490 4333 c0 -10 5 -35 11 -56 6 -22 8 -41 5 -45 -3 -3 -36 16 -74
41 -119 83 -132 56 -47 -98 30 -54 55 -102 55 -106 0 -3 -24 -15 -52 -26 -29
-11 -102 -48 -163 -81 -137 -75 -137 -74 -62 -227 91 -185 264 -455 291 -455
8 0 26 17 42 38 51 67 146 161 196 193 47 31 52 32 131 26 94 -6 312 -59 337
-82 23 -21 57 -19 69 4 19 34 -5 74 -72 123 -65 49 -127 108 -111 108 5 0 36
-9 68 -20 84 -28 147 -26 184 5 40 33 81 116 75 149 -6 28 -9 29 -98 46 -76
14 -154 38 -182 56 -13 8 -34 36 -47 63 -35 69 -81 105 -162 126 -101 27 -152
52 -203 100 -53 49 -169 135 -182 135 -5 0 -9 -8 -9 -17z"
        />
        <path
          d="M3260 4251 c0 -90 119 -330 177 -356 12 -5 24 -22 27 -39 9 -46 24
-56 77 -56 48 0 49 -1 43 -26 -9 -35 7 -44 85 -44 62 0 63 -1 57 -24 -5 -21
-2 -25 24 -31 17 -4 49 -4 73 0 l42 7 -20 -22 -20 -23 70 6 c39 4 82 9 98 13
23 5 27 3 27 -14 0 -12 10 -28 22 -36 l22 -16 -55 -57 c-82 -85 -120 -153
-164 -293 -62 -196 -167 -289 -308 -273 -45 5 -49 4 -80 -33 -69 -82 -194
-207 -241 -242 -40 -29 -63 -38 -125 -46 -74 -11 -76 -12 -98 -51 -12 -22 -25
-57 -28 -77 -7 -35 -5 -39 21 -48 54 -21 183 22 274 91 113 85 221 160 266
184 l49 26 170 -7 170 -6 165 62 c242 92 309 129 444 249 l69 61 111 0 c118 0
183 -13 256 -50 70 -35 330 -181 379 -212 87 -55 91 -37 16 81 -55 86 -92 178
-116 287 -13 57 -18 63 -146 187 -157 153 -186 193 -208 292 -9 41 -25 85 -35
97 -17 22 -25 23 -132 22 -63 0 -160 -9 -218 -19 -69 -12 -153 -19 -245 -19
-133 0 -146 2 -264 37 -69 21 -164 55 -213 77 -155 69 -351 208 -441 313 -55
64 -77 72 -77 28z"
        />
        <path
          d="M3758 4133 c-22 -26 -48 -79 -48 -100 0 -30 77 -69 240 -122 172 -55
185 -58 217 -47 23 7 143 130 143 146 0 11 -3 12 -170 45 -109 22 -305 72
-351 90 -8 3 -22 -2 -31 -12z"
        />
        <path
          d="M1676 3809 c-148 -5 -160 -7 -177 -27 -18 -23 -16 -54 5 -71 21 -18
121 -22 547 -24 441 -2 460 0 475 45 8 25 -20 66 -49 72 -35 8 -625 12 -801 5z"
        />
        <path
          d="M3194 3736 c-89 -17 -143 -41 -247 -110 -114 -74 -349 -193 -412
-207 -47 -10 -56 -9 -116 16 -86 36 -119 43 -151 32 -40 -13 -66 -64 -79 -153
-15 -112 -35 -207 -60 -294 -44 -150 -24 -368 34 -389 49 -18 82 21 107 129
19 82 33 109 98 196 69 93 200 220 265 259 55 32 205 86 314 114 105 27 424
68 595 77 l137 7 96 78 c53 43 96 82 96 86 0 4 -32 15 -72 24 -42 10 -124 43
-198 80 l-126 63 -105 3 c-58 1 -137 -4 -176 -11z"
        />
        <path
          d="M5930 3478 c-569 -195 -540 -182 -540 -232 0 -68 35 -146 131 -296
l48 -75 -15 -95 c-25 -149 -12 -350 38 -570 24 -109 43 -158 93 -236 l36 -56
125 4 c129 3 149 10 137 47 -10 28 -46 61 -67 61 -31 1 -98 34 -122 61 -30 34
-44 82 -51 181 -4 61 -2 92 6 102 6 7 57 26 114 42 110 30 147 55 147 99 0 37
-38 71 -90 79 -80 12 -110 26 -110 49 0 36 60 113 115 146 66 40 75 39 75 -6
0 -21 4 -44 9 -51 10 -16 372 -106 491 -122 46 -6 101 -20 122 -31 44 -23 89
-80 127 -166 42 -92 49 -101 113 -148 70 -52 112 -58 154 -22 39 34 34 65 -22
137 -27 34 -77 103 -111 153 -34 51 -74 109 -88 130 -31 47 -63 66 -195 119
-139 55 -254 113 -279 140 -30 32 -27 92 10 179 22 51 29 81 25 102 -3 17 -52
99 -109 183 -76 114 -107 153 -122 153 -11 0 -99 -28 -195 -61z"
        />
        <path
          d="M1146 3394 c-24 -24 -20 -61 9 -80 21 -14 41 -16 101 -11 81 6 124
26 124 57 0 40 -26 50 -125 50 -72 0 -97 -4 -109 -16z"
        />
        <path
          d="M1540 3390 c-31 -31 -25 -57 17 -79 26 -13 390 -27 446 -17 65 12 87
56 47 96 -19 19 -33 20 -255 20 -222 0 -236 -1 -255 -20z"
        />
        <path
          d="M1610 3139 c-144 -11 -190 -20 -204 -42 -29 -46 60 -65 342 -74 176
-6 194 -5 212 12 29 26 26 69 -6 94 -23 18 -39 21 -128 20 -55 -1 -153 -6
-216 -10z"
        />
        <path
          d="M4604 3048 c-35 -39 -174 -137 -262 -184 -48 -26 -100 -59 -117 -74
-16 -15 -64 -50 -105 -77 -114 -76 -110 -64 -72 -212 17 -69 36 -158 42 -197
12 -88 32 -136 66 -163 23 -18 40 -21 125 -21 96 0 99 1 99 23 0 34 -27 65
-76 88 -24 12 -57 37 -74 55 -28 33 -30 39 -30 122 0 80 3 92 29 135 41 63 90
93 179 106 96 15 187 52 248 102 63 53 137 155 164 227 l21 57 -21 17 c-18 14
-41 18 -110 18 -76 0 -89 -3 -106 -22z"
        />
        <path
          d="M1380 2866 c-149 -12 -170 -17 -170 -41 0 -22 14 -26 148 -40 208
-22 492 -29 522 -13 32 17 36 48 11 79 -19 24 -22 24 -193 26 -95 0 -238 -4
-318 -11z"
        />
        <path
          d="M5235 2798 c-3 -35 -20 -115 -37 -178 -49 -186 -49 -187 -37 -217 19
-50 48 -73 93 -73 37 0 205 26 212 32 1 2 4 93 5 203 l4 199 -105 44 c-58 24
-110 45 -116 48 -8 4 -14 -16 -19 -58z"
        />
        <path
          d="M1036 2739 c-28 -41 17 -111 128 -194 228 -172 572 -238 1247 -239
354 -1 359 0 359 54 0 15 -9 35 -21 46 -20 18 -46 19 -383 25 -706 13 -955 67
-1200 259 -49 38 -95 70 -102 70 -7 0 -20 -10 -28 -21z"
        />
        <path
          d="M2476 2729 c-33 -26 -33 -49 0 -80 25 -24 27 -24 220 -23 173 1 197
3 215 20 13 12 19 28 17 48 -5 46 -42 55 -249 55 -164 1 -178 0 -203 -20z"
        />
      </g>
    </svg>
  );
};

export default CanicrossIcon;
